module.exports = __webpack_public_path__ + "img/download.000bba6d.png";